export default (catergorylinks) => {
    
    let r = `
        <div class="container header__container">
            <div class="row ">
                <div class="col-12 text-center">
                    <a href="https://www.kongsberg.kommune.no" class="municmark__link">
                       <img src="/dist/images/logo-kommunevaapen-staaende.svg" class="municmark__img">
                    </a>
                </div>
                <div class="col-6">
                    <a href="/" class="logo__link">
                        <img src="/dist/images/logo-kongsberghistoriefortelling.svg" class="logo__img d-none d-lg-block">
                        <img src="/dist/images/logo-tolinjer-kongsberghistoriefortelling.svg" class="logo__img logo__img-mobile d-block d-lg-none">
                        <h1 class="sr-only">Kongsberg historiefortelling</h1>
                    </a>
                </div>
                <div class="col-6 text-right">
                    <button class="btn btn-nav" id="togglemenu">
                        <span class="material-icons-outlined btn-nav__icon" id="logoicon-arrow" >menu</span>
                        <span class="material-icons-outlined d-none btn-nav__icon"  id="logoicon-close">close</span>
                        <span class="d-none d-sm-inline" id="menu-text">Meny</span>
                    </button> 
                </div>
            </div>
        </div>
        <div class="container globalnav__container d-none">
            <div class="row row-eq-height">
                <div class="col-lg-8 mb-5 order-12 order-lg-1">
                    <div class="globalnav globalnav-history">
                        <h2 class="globalnav__title">Historiefortelling</h2>
                        <div class="row">
                            ${catergorylinks}
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 mb-md-5 mb-3 order-1 order-lg-12">
                    <div class="globalnav globalnav-libary text-center">
                        <h2 class="globalnav__title">Kommuneleksikon</h2>
                        <div>
                            <a href="/kommuneleksikon" class="globalnav__biglink" ><span class="material-icons-outlined globalnav__bigicon icon__whitecircle">search</span></a>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        
    
    
    `;
    
    
    return r;
    
}

export const categorylink = (category, parent) => {
    return `
        
        <div class="col-lg-6 col-xxl-4">
        <a href="/${urlify(parent.previewItem)}#${urlify(category.item)}" data-navcatitem="${category.item}" class="globalnav__link"><span class="material-icons-outlined icon__whitecircle">arrow_forward</span>${category.previewItem}</a>
        </div>
    
    `;
}